export default class CourseCalendar {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    calendarColor: 'validString'
  }
  */
  async getCourseCalendar(courseID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/course/${courseID}/calendar`;
    return await req.exec();
  }
  async upsertCourseCalendar(courseID, calendarColor) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/course/${courseID}/calendar`;
    req.body = { calendarColor };
    return await req.exec();
  }
}
